import Select from 'react-select';

const Option = props => {
  const { children, innerProps, innerRef, isDisabled, data, selectProps } =
    props;
  const { onDeleteOption } = selectProps;

  const handleDelete = event => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof onDeleteOption === 'function') {
      onDeleteOption(data);
    }
  };

  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 12px',
      }}
    >
      <span>{children}</span>
      {typeof onDeleteOption === 'function' && !isDisabled ? (
        <button
          type="button"
          onClick={handleDelete}
          aria-label={`Delete ${data?.label || 'option'}`}
          style={{
            border: 'none',
            background: 'transparent',
            color: '#dc2626',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: 1,
            padding: '0 0 0 8px',
          }}
        >
          ×
        </button>
      ) : null}
    </div>
  );
};

// Custom Select Dropdown with Search functunality
const CustomSelect = ({
  options,
  onChange,
  value,
  placeholder,
  id,
  name,
  isMulti,
  isClearable,
  isDisabled,
  onDeleteOption,
  ...other
}) => {
  return (
    <Select
      value={value}
      isClearable={isClearable}
      isMulti={isMulti}
      id={id}
      name={name}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onDeleteOption={onDeleteOption}
      components={{ Option }}
      {...other}
    />
  );
};

export default CustomSelect;
